import App from './App.tsx'
import { initAnalytics } from './analytics'
import './fonts.css'
import { TenantProvider } from './tenant/TenantContext'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider as HSDSProvider } from 'hsds/components/hsds'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { createQueryClient } from 'shared/utils/queryClient'
import 'vite/modulepreload-polyfill'

initAnalytics()

const queryClient = createQueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <HSDSProvider>
      <TenantProvider>
        {/* Host root, not BASE_URL: that's the CDN asset base in preview
            builds and would break <Link> hrefs. */}
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </TenantProvider>
    </HSDSProvider>
  </QueryClientProvider>,
  document.getElementById('customer-portal-app')
)
